// extracted by mini-css-extract-plugin
module.exports = {"adapterSlider":"b7_lp","adapterSlider_isNoMargin":"b7_lq","adapterSlider_isNegative":"b7_lr"};